const menuTypes = {
    school: '学院',
    bill: '订单',
    message: '消息',
    user: '个人中心'
};
export default menuTypes;


// WEBPACK FOOTER //
// ./src/enum/enum.js